// src/components/Seo.js
// Sayfa başlığı, meta etiketleri, canonical ve JSON-LD'yi günceller.
// Ön-oluşturulmuş HTML'deki etiketlerin üzerine yazar (yinelenen etiket oluşmaz).
import { useEffect } from 'react';
import site from '../data/site.json';

export const fullTitle = (t) => (!t ? site.title : t.includes('Oyuntu') ? t : `${t} | Oyuntu`);

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (value == null || value === '') {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * @param {object} p
 * @param {string} p.title        Sayfa başlığı ("| Oyuntu" otomatik eklenir)
 * @param {string} p.description  140–160 karakter
 * @param {string} p.path         Canonical yol, ör. "/oyun/pisti"
 * @param {string} [p.image]      Paylaşım görseli yolu
 * @param {object} [p.jsonLd]     schema.org grafiği
 * @param {boolean} [p.noindex]
 * @param {string} [p.type]       og:type
 */
export default function Seo({ title, description, path = '/', image, jsonLd, noindex = false, type = 'website' }) {
  const t = fullTitle(title);
  const url = `${site.url}${path}`;
  const img = `${site.url}${image || site.ogImage}`;
  const ld = jsonLd ? JSON.stringify(jsonLd) : '';

  useEffect(() => {
    document.title = t;
    setMeta('name', 'description', description || site.description);
    setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large');
    setLink('canonical', url);
    setMeta('property', 'og:title', t);
    setMeta('property', 'og:description', description || site.description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:image', img);
    setMeta('name', 'twitter:title', t);
    setMeta('name', 'twitter:description', description || site.description);
    setMeta('name', 'twitter:image', img);

    let script = document.getElementById('ld-page');
    if (ld) {
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = 'ld-page';
        document.head.appendChild(script);
      }
      if (script.textContent !== ld) script.textContent = ld;
    } else if (script) {
      script.remove();
    }
  }, [t, description, url, img, ld, noindex, type]);

  return null;
}
